import { Routes } from '@angular/router';

export const NotFoundRouting: Routes = [
  {
    path: 'not-found',
    title: 'Không tìm thấy',
    loadComponent: () => import('./not-found.component').then((m) => m.NotFoundComponent),
  },
];
